import { useMutation } from "@tanstack/react-query";
import { instance } from "libs/api";

import { DirectUploadRequest, DirectUploadResp } from "../directUpload.types";

const fetcher = async (
  body: DirectUploadRequest
): Promise<DirectUploadResp> => {
  return await instance.post("media", body);
};

export const useDirectUpload = () => {
  return useMutation(fetcher);
};
